import axios from "axios";
import { touchSession } from "@/composables/tokenRefresh";

const api = axios.create({
  baseURL: import.meta.env.VITE_APP_DAS_BASE_URL
})

api.interceptors.request.use((config) => {
    config.headers.Authorization  = "Bearer "+import.meta.env.VITE_APP_DAS_API_KEY
    return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response !== undefined && (error.response.status === 401)) {
      localStorage.clear()
      sessionStorage.clear()
      touchSession()
      alert('session expired, please login again to continue')
    }

    return Promise.reject(error)
  }
)

export default api
